import {useEffect, useState} from "react";
import ROIFilterTeamRow from "./ROIFilterTeamRow";


const ROIFilterOrganisationRow = (props) => {

    const [organisation, setOrganisation] = useState(null)
    const [rowExpanded, setRowExpanded] = useState(false)
    const [selectState, setSelectState] = useState(0)

    useEffect(() => {
        setOrganisation(props.organisation)
    }, [props.organisation]);

    useEffect(() => {
        if(!organisation) return;
        let found_matches = 0

        for(const team of organisation.teams) {
            for (const selected of props.selected) {
                if((selected.team_id === team.team_id) && (selected.demo === team.demo)) {
                    found_matches += 1
                    break;
                }
            }
        }

        if(found_matches === organisation.teams.length) {
            setSelectState(2)
        } else if(found_matches > 0) {
            setSelectState(1)
        } else {
            setSelectState(0)
        }

    }, [props.selected, organisation])

    const toggleRow = (ev) => {
        if(!ev) return;
        if(ev.target.id === "toggle") {
            setRowExpanded(!rowExpanded)
        }
    }

    const handleBoxClick = (ev) => {
        if(!ev) return;
        if(selectState !== 1) {
            props.update(organisation.teams)
        } else {
            let temp_list = []
            for(const team of organisation.teams) {
                let match_found = false
                for(const selectedTeam of props.selected) {
                    if ((selectedTeam.team_id === team.team_id) && (selectedTeam.demo === team.demo)) {
                        match_found = true;
                        break;
                    }
                }
                if(!match_found) temp_list.push(team);
            }
            props.update(temp_list)
        }
    }

    return (
        <div className="roi-filter-organisation-row-container">
            <div className="roi-filter-organisation-row" onClick={toggleRow}>
                {rowExpanded ?
                    <div className="filter-open-arrow" id="toggle"/> :
                    <div className="filter-closed-arrow" id="toggle"/>
                }
                <div className={`roi-filter-selected-box ${selectState > 0 ? "filled": ""}`} onClick={handleBoxClick}>
                    {selectState === 2 ? "✓" : selectState === 1 ? "-" : ""}
                </div>
                <div className="filter-colour-circle" id="toggle" style={{backgroundColor: organisation && organisation.colour}}/>
                <div className="filter-organisation-name regular" id="toggle">{organisation && organisation.name}</div>
            </div>
            <div className="roi-filter-organisation-teams-container">
                {rowExpanded ?
                    organisation && organisation.teams.map((team, idx) => {
                        return <ROIFilterTeamRow team={team} key={idx} colour={organisation && organisation.colour}
                                                 selected={props.selected} update={props.update.bind(this)}/>
                    }) : null
                }
            </div>
        </div>
    )
}


export default ROIFilterOrganisationRow